// Shallow equality for two string arrays (same length, same elements in order).
export const sameStringArray = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((value, index) => value === b[index]);
